import React from 'react';

export const WORKING_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const EMPTY_DAY = { open: '', close: '', closed: false };

// True once any day has been filled in; an untouched schedule is saved as "not set".
export const hasWorkingHours = (hours) =>
    Boolean(hours) && WORKING_DAYS.some((day) => hours[day]?.closed || hours[day]?.open || hours[day]?.close);

export const workingHoursError = (hours) => {
    if (!hasWorkingHours(hours)) return null;
    const incomplete = WORKING_DAYS.find((day) => !hours[day]?.closed && !(hours[day]?.open && hours[day]?.close));
    if (!incomplete) return null;
    return `Working hours: set open and close times for ${incomplete[0].toUpperCase()}${incomplete.slice(1)}, or mark it closed.`;
};

const WorkingHoursEditor = ({ value, onChange }) => {
    const updateDay = (day, patch) => {
        const next = {};
        WORKING_DAYS.forEach((name) => {
            next[name] = { ...EMPTY_DAY, ...(value?.[name] || {}) };
        });
        next[day] = { ...next[day], ...patch };
        onChange(next);
    };

    return (
        <div className="d-flex flex-column gap-2">
            {WORKING_DAYS.map((day) => {
                const current = { ...EMPTY_DAY, ...(value?.[day] || {}) };
                return (
                    <div className="d-flex align-items-center flex-wrap gap-3" key={day}>
                        <span className="text-sm fw-medium text-dark text-capitalize" style={{ width: '100px' }}>{day}</span>
                        <input
                            type="time"
                            className="form-control form-control-sm radius-8"
                            style={{ width: '130px' }}
                            aria-label={`${day} opening time`}
                            value={current.open}
                            disabled={current.closed}
                            onChange={(e) => updateDay(day, { open: e.target.value })}
                        />
                        <span className="text-sm text-secondary-light">to</span>
                        <input
                            type="time"
                            className="form-control form-control-sm radius-8"
                            style={{ width: '130px' }}
                            aria-label={`${day} closing time`}
                            value={current.close}
                            disabled={current.closed}
                            onChange={(e) => updateDay(day, { close: e.target.value })}
                        />
                        <label className="form-check d-flex align-items-center gap-2 mb-0">
                            <input
                                type="checkbox"
                                className="form-check-input mt-0"
                                checked={current.closed}
                                onChange={(e) => updateDay(day, { closed: e.target.checked })}
                            />
                            <span className="text-sm">Closed</span>
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default WorkingHoursEditor;
